import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CrudService } from 'src/app/demo/service/crud.service';
import { AlertsService } from 'src/app/demo/service/alerts.service';
import { Field } from 'src/app/demo/interfaces/form-print.interface';
import { CoreUtilsService } from '../../utils/core-utils.service';
import { lastValueFrom } from 'rxjs';
import { FormPrintTwoComponent } from '../form-print-two/form-print-two.component';

@Component({
  selector: 'app-dialog-form-dynamic-three',
  templateUrl: './dialog-form-dynamic-three.component.html',
  styleUrl: './dialog-form-dynamic-three.component.scss'
})
export class DialogFormDynamicThreeComponent implements OnInit, AfterViewInit {

  @ViewChild('formPrintTwo') formPrintTwo: FormPrintTwoComponent;

  questions: Field[] = [];
  typeOfAction: 'view' | 'add' = null;
  canCreate: boolean = false;
  canEdit: boolean = false;
  canRequestModification: boolean = false;
  rolType: string = null;
  showModalButtons: boolean = false;
  showModalBtnEdit: boolean = false;

  /**
    * @author Ministerio de Cultura
    * @createdate 2025-04-02
    * @description Almacena el estado de validación de cada paso del formulario en el componente <app-form-print/>.
    * Cada índice del arreglo representa un paso del formulario:
    * - `false` indica que el formulario no está validado.
    * - `true` indica que el formulario ha pasado la validación.
    */
  validFormPrint: { [key: string]: boolean } = {};

  constructor(
    private crudService: CrudService,
    private alertService: AlertsService,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private coreUtils: CoreUtilsService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.questions = this.dynamicDialogConfig.data.questions;


    const permissions_by_role = this.dynamicDialogConfig.data.permissions_by_role;
    this.typeOfAction = this.dynamicDialogConfig.data.typeOfAction;
    this.canCreate = permissions_by_role.add;
    this.canEdit = permissions_by_role.edit;
    this.canRequestModification = permissions_by_role.submit_modification;
    this.rolType = permissions_by_role.type

    this.showModalButtons = this.typeOfAction === 'add';
    this.showModalBtnEdit = this.typeOfAction === 'view';

    const { parent, key } = this.coreUtils.getTargetFromPath(this, "['questions']");
    parent[key].forEach((field: Field, position: number) => {
      parent[key] = this.coreUtils.setFieldDisabled(parent[key], position, this.typeOfAction === 'view');
    })

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const modalBody = document.querySelector('.p-dialog-content') as HTMLElement;
      if (modalBody) {
        modalBody.scrollTop = 0;
      }
    }, 100);
  }

  async onSubmit() {
    const confirmFrom = await this.alertService.showConfirmAlert({ html: '¿Desea enviar la información registrada?' });
    if (!confirmFrom.isConfirmed) return;

    const apiString = this.dynamicDialogConfig.data.apiString;
    const typeOfAction: 'add' | 'view' = this.dynamicDialogConfig.data.typeOfAction;
    const form = this.formPrintTwo.form;
    let res = null;

    if (apiString) {
      if (typeOfAction === 'add')
        res = await this.saveData(apiString.save, form.value);
      else if (typeOfAction === 'view')
        res = await this.updateData(apiString.update, form.value, form.value.id);

      this.alertService.showAlertNotification({ html: res.message });
      this.dynamicDialogRef.close(res);
    } else {
      this.dynamicDialogRef.close(form);
    }
  }

  async saveData(endpointName: string, form: any): Promise<any> {
    try {
      return await lastValueFrom(
        this.crudService.postData({ url: endpointName, formData: form })
      );
    } catch (err) {
      console.error('❌ Error al guardar los datos:', err);
      throw err;
    }
  }

  async updateData(endpointName: string, form: any, _id: number): Promise<any> {
    try {
      return await lastValueFrom(
        this.crudService.putData({ url: endpointName, id: _id, formData: form })
      );
    } catch (err) {
      console.error('❌ Error al actualizar los datos:', err);
      throw err;
    }
  }

  onClickEdit() {
    const { parent, key } = this.coreUtils.getTargetFromPath(this, "['questions']");
    parent[key].forEach((field: Field, position: number) => {
      parent[key] = this.coreUtils.setFieldDisabled(parent[key], position, false);
    })

    this.dynamicDialogConfig.header = 'Editar información';
    this.showModalButtons = true;
    this.showModalBtnEdit = false;
  }

  onCancel(): void {
    this.dynamicDialogRef.close();
  }

  /**
   * @author Ministerio de cultura
   * @createdate 2025-04-02
   * @description Verifica si el botón de submit o guardar debe estar deshabilitado.
   * El botón estará deshabilitado si todos los elementos del array `validFormPrint` son `true`
   *
   * @returns {boolean} `true` si el botón debe estar deshabilitado, `false` en caso contrario.
   */
  get btnIsDisabled(): boolean {
    return Object.values(this.validFormPrint).every(item => item === true);
  }

  onValidFormChange(key: string, value: boolean): void {
    this.validFormPrint[key] = value;
    this.cdr.detectChanges();
  }
}

